import baseWorkloadApi from './baseWorkloadApi';

export interface AiUsageTokenTotals {
  requests: number;
  promptTokens: number;
  cachedTokens: number;
  completionTokens: number;
  totalTokens: number;
  costUSD: number;
  /** cachedTokens / promptTokens, 0-1 */
  cacheHitRate: number;
}

export interface AiUsageMetricsResponse {
  granularity: 'hour' | 'day';
  boundIds: { minId: number; maxId: number } | null;
  totals: AiUsageTokenTotals;
  byModel: ({ model: string; provider: string } & AiUsageTokenTotals)[];
  byProvider: ({ provider: string } & AiUsageTokenTotals)[];
  byCallsite: ({ callsite: string } & AiUsageTokenTotals)[];
  series: ({ bucket: string } & AiUsageTokenTotals)[];
  /** Top models' per-bucket tokens and hit rate, aligned with `series` buckets */
  seriesByModel: { model: string; provider: string; tokens: number[]; cacheHitRate: number[] }[];
  /** Filter options: everything seen in the period before model/provider filters */
  availableModels: { model: string; provider: string }[];
  availableProviders: string[];
  availableCallsites: string[];
}

export interface GetAiUsageMetricsParams {
  startDate: string;
  endDate: string;
  businessUnitId?: number;
  models?: string[];
  providers?: string[];
  callsites?: string[];
}

const aiUsageApi = baseWorkloadApi.injectEndpoints({
  endpoints: (build) => ({
    getAiUsageMetrics: build.mutation({
      query: (params: GetAiUsageMetricsParams) => ({
        url: '/admin/aiUsage/metrics',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: AiUsageMetricsResponse): AiUsageMetricsResponse => response,
    }),
  }),
  overrideExisting: false,
});

export const { useGetAiUsageMetricsMutation } = aiUsageApi;
